import React from 'react';

interface InfoOutlineIconProps extends React.SVGProps<SVGSVGElement> {
    colour?: string;
}

const InfoOutlineIcon = ({ colour = 'currentColor', ...rest }: InfoOutlineIconProps) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        {...rest}
    >
        <path
            d="M7.00228 1.16992C5.84856 1.16992 4.72074 1.51204 3.76146 2.15302C2.80217 2.79399 2.0545 3.70503 1.61298 4.77094C1.17147 5.83684 1.05595 7.00973 1.28103 8.14128C1.50611 9.27284 2.06169 10.3122 2.87749 11.128C3.6933 11.9439 4.7327 12.4994 5.86426 12.7245C6.99581 12.9496 8.1687 12.8341 9.2346 12.3926C10.3005 11.951 11.2115 11.2034 11.8525 10.2441C12.4935 9.2848 12.8356 8.15698 12.8356 7.00326C12.8356 6.23721 12.6847 5.47867 12.3916 4.77094C12.0984 4.0632 11.6687 3.42014 11.1271 2.87847C10.5854 2.33679 9.94234 1.90711 9.2346 1.61396C8.52687 1.32081 7.76833 1.16992 7.00228 1.16992V1.16992ZM7.00228 11.6699C6.0793 11.6699 5.17705 11.3962 4.40962 10.8834C3.64219 10.3707 3.04405 9.64183 2.69084 8.78911C2.33763 7.93639 2.24522 6.99808 2.42528 6.09283C2.60535 5.18759 3.0498 4.35607 3.70245 3.70342C4.3551 3.05078 5.18662 2.60632 6.09186 2.42626C6.99711 2.24619 7.93542 2.33861 8.78814 2.69182C9.64086 3.04503 10.3697 3.64316 10.8825 4.41059C11.3953 5.17802 11.6689 6.08028 11.6689 7.00326C11.6689 8.24093 11.1773 9.42792 10.3021 10.3031C9.42694 11.1783 8.23996 11.6699 7.00228 11.6699V11.6699Z"
            fill={colour}
        />
        <path
            d="M7.00228 5.25651C7.32444 5.25651 7.58561 4.99534 7.58561 4.67318C7.58561 4.35101 7.32444 4.08984 7.00228 4.08984C6.68011 4.08984 6.41895 4.35101 6.41895 4.67318C6.41895 4.99534 6.68011 5.25651 7.00228 5.25651Z"
            fill={colour}
        />
        <path
            d="M7.00228 5.83398C6.84757 5.83398 6.6992 5.89544 6.5898 6.00484C6.4804 6.11424 6.41895 6.26261 6.41895 6.41732V9.33399C6.41895 9.4887 6.4804 9.63707 6.5898 9.74647C6.6992 9.85586 6.84757 9.91732 7.00228 9.91732C7.15699 9.91732 7.30536 9.85586 7.41476 9.74647C7.52415 9.63707 7.58561 9.4887 7.58561 9.33399V6.41732C7.58561 6.26261 7.52415 6.11424 7.41476 6.00484C7.30536 5.89544 7.15699 5.83398 7.00228 5.83398Z"
            fill={colour}
        />
    </svg>
);

export default InfoOutlineIcon;
